import Axios from "axios";
import Url from "app/shared/constants/Url";
const FetchCategoryList = async({page, search = "", module}) => {
    let URL = Url.documentCategory.categoryList;
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    const requestParams = {
      auth_key: token,
      user_id: userId,
      
    };
    try {
        const response = await Axios.get(`${URL}?module=${module}&page=${encodeURIComponent(page)}&sortBy=&sortDirection=desc&search=${encodeURIComponent(search)}&size=10`,{
          params:requestParams,

          headers: {
            'accept': 'application/json',
            'Content-Type': 'multipart/form-data'  
          }
        });
        console.log(response,"response")
        if (response.status === 200) {
            return response.data;
          }        
      } catch (error) {
        console.error("Error fetching category", error.response?.data || error.message);
        throw error;
      } 
};

export default FetchCategoryList;

// ?page=${encodeURIComponent(page)}&size=${encodeURIComponent(size)}